var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#94DDDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5375_2832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5018 11.4993V9.86958C17.5018 9.47162 17.3436 9.08999 17.0621 8.80864L14.9402 6.68675C14.6589 6.40531 14.2773 6.24707 13.8793 6.24707H8.49806C7.66929 6.24707 6.99744 6.91892 6.99744 7.7477V18.2521C6.99744 19.0808 7.66929 19.7527 8.49806 19.7527H11.4993",
    stroke: "#194142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5018 9.99863H14.5006C14.0862 9.99863 13.7502 9.66271 13.7502 9.24832V6.24707",
    stroke: "#194142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7502,
    y: 16.939,
    width: 2.25094,
    height: 2.81367,
    stroke: "#194142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0012,
    y: 13.75,
    width: 2.25094,
    height: 6.0025,
    stroke: "#194142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2522,
    y: 15.4385,
    width: 2.25094,
    height: 4.3143,
    stroke: "#194142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5375_2832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.b6051dc06983616922851b950c401cad.svg";
export { ForwardRef as ReactComponent };